import { render, staticRenderFns } from "./Carteraprocesoclinico.vue?vue&type=template&id=0bb56d6a"
import script from "./Carteraprocesoclinico.vue?vue&type=script&lang=js"
export * from "./Carteraprocesoclinico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports